/**
 * Extend Quote Modal — built on TradeModal.
 *
 * Expects the modal HTML to already exist in the DOM (rendered by
 * snippets/extend-quote-modal.liquid via trade-modal.liquid).
 *
 * Exposes:
 *   window.TradeExtendQuoteModal.open(quoteId)
 *   window.TradeExtendQuoteModal.close()
 */
(function () {
	if (window.TradeExtendQuoteModal) return;

	const overlay = document.getElementById('extend-quote-modal');
	if (!overlay) return;

	const modal = new TradeModal(overlay);

	const errorContainer = document.getElementById('extend-quote-error-message');
	const errorText = document.getElementById('extend-quote-error-text');

	let currentQuoteId = null;
	let isSubmitting = false;

	function showState(state) {
		overlay.querySelectorAll('[data-state]').forEach(function (el) {
			if (el.dataset.state === state) {
				el.classList.remove('trade-modal__section--hidden');
			} else {
				el.classList.add('trade-modal__section--hidden');
			}
		});
	}

	function hideError() {
		if (errorContainer) errorContainer.classList.add('trade-modal__section--hidden');
	}

	function showError(message) {
		if (errorContainer && errorText) {
			errorText.textContent = message;
			errorContainer.classList.remove('trade-modal__section--hidden');
		}
	}

	async function extendQuote() {
		// Guard against double-submit while a request is in flight
		if (isSubmitting || !currentQuoteId) return;
		isSubmitting = true;
		hideError();
		showState('loading');

		try {
			const data = await window.QuoteService.extendQuote(currentQuoteId);
			showState('success');
			document.dispatchEvent(new CustomEvent('trade:quote-extended', {
				detail: { quoteId: currentQuoteId, quote: data && data.quote },
			}));
			modal._autoCloseTimer = setTimeout(function () {
				modal.close();
			}, 3000);
		} catch (err) {
			// tradeFetch extracts the server's error message for known statuses
			showState('idle');
			showError(err.message || 'Something went wrong. Please try again.');
		} finally {
			isSubmitting = false;
		}
	}

	// Confirm button click
	overlay.addEventListener('click', function (e) {
		if (e.target.closest('[data-extend-confirm]')) {
			extendQuote();
		}
	});

	// Public API
	window.TradeExtendQuoteModal = {
		open: function (quoteId) {
			currentQuoteId = quoteId;
			hideError();
			showState('idle');
			modal.open();
		},

		close: function () {
			modal.close();
		}
	};
})();
